<div class="step-container registration-refer-a-friend">
  <ng-container *ngIf="loading">
    <div class="w-100">
      <fgbcl-loading></fgbcl-loading>
    </div>
  </ng-container>
  <ng-container *ngIf="!loading">
    <i class="material-icons info-icon">info</i>
    <h5 class="register-refer-a-friend-title">{{ 'fgbcl.registration.refer.a.friend.title' | translate }}</h5>
    <p
      class="register-refer-a-friend-subtitle"
      [innerHtml]="'fgbcl.registration.refer.a.friend.subtitle' | translate | markdownTranslate"
    ></p>
  </ng-container>

  <div class="action-wrapper mt-auto" *ngIf="showBackButton">
    <a class="btn btn-success btn-block font-size-14 w-100 fw-bold" aria-label="Login" (click)="backToLogin()">
      <div>{{ 'registration.refer.a.friend.back.button' | translate: { fgbdefault: 'Back to Login' } }}</div>
    </a>
  </div>
</div>
